module.exports = __webpack_public_path__ + "img/banner_home.b6a8eba7.png";